import { render, staticRenderFns } from "./PinnedMessage.vue?vue&type=template&id=5a7ed40b&scoped=true&"
import script from "./PinnedMessage.vue?vue&type=script&lang=js&"
export * from "./PinnedMessage.vue?vue&type=script&lang=js&"
import style0 from "./PinnedMessage.vue?vue&type=style&index=0&id=5a7ed40b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ed40b",
  null
  
)

export default component.exports